const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export interface YouTubeDownloadRequest {
  youtube_url: string;
  artist_id: string;
}

export interface YouTubeDownloadResponse {
  success: boolean;
  submissions?: any[];
  count?: number;
  error?: string;
}

export class YouTubeDownloadService {
  static async downloadVideo(request: YouTubeDownloadRequest): Promise<YouTubeDownloadResponse> {
    try {
      console.log('Calling youtube-download-submission with:', request);
      console.log('Supabase URL:', supabaseUrl);

      const response = await fetch(
        `${supabaseUrl}/functions/v1/youtube-download-submission`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${supabaseAnonKey}`,
            'apikey': supabaseAnonKey,
          },
          body: JSON.stringify(request),
        }
      );

      console.log('Response status:', response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', errorText);
        return {
          success: false,
          error: `HTTP ${response.status}: ${errorText}`,
        };
      }

      const data = await response.json();
      console.log('Response data:', data);

      return {
        success: true,
        submissions: data.submissions || [],
        count: data.count || 0,
      };
    } catch (error: any) {
      console.error('Error downloading video:', error);
      console.error('Error details:', JSON.stringify(error, null, 2));
      return {
        success: false,
        error: error.message || 'Unknown error occurred',
      };
    }
  }
}
